/* Soolla Announcement Bars — client controller.
   Phases: geo two-layer, new/returning, UTM match + CTA injection, A/B + attribution,
   discount copy/auto-apply, Klaviyo capture (dormant), social-proof, recurring countdowns,
   per-slot precedence + CLS-safe reveal, per-handle dismissal. No third-party dependency. */
(function () {
  'use strict';
  var root = document.getElementById('soolla-bars');
  if (!root) return;

  var DESIGN = !!(window.Shopify && window.Shopify.designMode) || root.dataset.designMode === '1';
  var serverCountry = (root.dataset.serverCountry || 'US').toUpperCase();
  var geoEndpoint = root.dataset.geoEndpoint || '';
  var logEndpoint = root.dataset.logEndpoint || '';
  var geoUpgrade = root.dataset.geoUpgrade === '1';
  var KLAVIYO_ENABLED = false; // deferred per merchant; capture UI shows success optimistically

  var bars = Array.prototype.slice.call(root.querySelectorAll('[data-bar]'));
  if (!bars.length) return;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- responsive copy: "Desktop wording || Mobile wording" ---------- */
  var MOBILE_MQ = window.matchMedia ? window.matchMedia('(max-width: 749px)') : null;
  var COPY_SPLIT = '||';
  var LINK_SPLIT = '@@';
  /* Announcement messages: one per line (or "~~"), each "Desktop || Mobile @@ /link". */
  function safeUrl(u) {
    u = (u || '').trim();
    return (/^https?:\/\//i.test(u) || u.charAt(0) === '/') ? u : '';
  }
  function parseMessages(raw) {
    return String(raw || '').split(/\r?\n|~~/).map(function (ln) {
      ln = ln.trim(); if (!ln) return null;
      var at = ln.indexOf(LINK_SPLIT), url = '';
      if (at > -1) { url = safeUrl(ln.slice(at + LINK_SPLIT.length)); ln = ln.slice(0, at).trim(); }
      return ln ? { copy: ln, url: url } : null;
    }).filter(Boolean);
  }
  function isMobileView() { return !!(MOBILE_MQ && MOBILE_MQ.matches); }
  function pickCopy(s) {
    s = s || '';
    var i = s.indexOf(COPY_SPLIT);
    if (i === -1) return s;
    var desk = s.slice(0, i).trim(), mob = s.slice(i + COPY_SPLIT.length).trim();
    return (isMobileView() && mob) ? mob : (desk || mob);
  }
  function hasSplitCopy(c) {
    var m = c.messages || [];
    for (var i = 0; i < m.length; i++) if (m[i].copy.indexOf(COPY_SPLIT) > -1) return true;
    return (c.templateRaw || '').indexOf(COPY_SPLIT) > -1 || (c.successRaw || '').indexOf(COPY_SPLIT) > -1;
  }
  var loggedImpr = {};

  /* ---------- helpers ---------- */
  function parseList(v) {
    try { var a = JSON.parse(v); return Array.isArray(a) ? a.map(function (x) { return String(x).toUpperCase().trim(); }) : []; }
    catch (e) { return []; }
  }
  function cookieGet(n) { var m = document.cookie.match('(?:^|; )' + n + '=([^;]*)'); return m ? decodeURIComponent(m[1]) : null; }
  function cookieSet(n, v, days) {
    var d = new Date(); d.setTime(d.getTime() + (days || 365) * 864e5);
    var secure = location.protocol === 'https:' ? '; Secure' : '';
    document.cookie = n + '=' + encodeURIComponent(v) + '; expires=' + d.toUTCString() + '; path=/; SameSite=Lax' + secure;
  }
  function money(cents) {
    var c = (cents || 0) / 100;
    var s = (Math.round(c * 100) / 100).toFixed(2).replace(/\.00$/, '');
    return '$' + s;
  }
  function fillTokens(tpl, map) {
    return (tpl || '').replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, k) { return (k in map) ? map[k] : ''; });
  }

  /* ---------- signals ---------- */
  var seen = cookieGet('soolla_v');
  var isReturning = !!seen;
  if (!seen) { try { cookieSet('soolla_v', '1', 730); } catch (e) {} }

  var utm = {};
  try {
    var qs = new URLSearchParams(location.search);
    ['source', 'medium', 'campaign', 'content', 'term'].forEach(function (k) {
      var v = qs.get('utm_' + k); if (v) utm[k] = v;
    });
    if (Object.keys(utm).length) { sessionStorage.setItem('soolla_utm', JSON.stringify(utm)); }
    else { utm = JSON.parse(sessionStorage.getItem('soolla_utm') || '{}'); }
  } catch (e) { utm = {}; }

  var geo = { country: serverCountry, region: '', city: '' };
  var pageType = root.dataset.pageType || '';

  /* ---------- per-bar config ---------- */
  function cfg(el) {
    var d = el.dataset;
    var msgs = d.type === 'announcement' ? parseMessages(d.template) : [];
    var tpl = msgs.length ? msgs[0].copy : (d.template || '');
    return {
      el: el, handle: d.handle, type: d.type, slot: d.slot || 'primary',
      priority: parseInt(d.priority, 10) || 0,
      countries: parseList(d.countries), regions: parseList(d.regions),
      segment: d.segment || 'all', motion: d.motion || 'scroll',
      utmSource: (d.utmSource || '').toLowerCase(), utmCampaign: (d.utmCampaign || '').toLowerCase(),
      utmMedium: (d.utmMedium || '').toLowerCase(), matchLogic: d.matchLogic || 'all',
      templateRaw: tpl, template: pickCopy(tpl), messages: msgs, hold: parseFloat(d.hold) || 4.5,
      successRaw: d.success || '', success: pickCopy(d.success || ''),
      ctaUrl: d.ctaUrl || '', injectUtm: d.injectUtm !== '0', ctaUtmCampaign: d.ctaUtmCampaign || '',
      discount: d.discount || '',
      cdMode: d.countdownMode || '', cdDeadline: d.countdownDeadline || '', cdWindow: d.countdownWindow || '',
      cdDuration: parseInt(d.countdownDuration, 10) || 0,
      threshold: parseInt(d.threshold, 10) || 0,
      klaviyoList: d.klaviyoList || '', captureType: d.captureType || '',
      abTest: d.abTest || '', variant: d.variant || '', abWeight: parseInt(d.abWeight, 10) || 1,
      spWindow: parseInt(d.spWindow, 10) || 24, dismissible: d.dismissible === '1',
      cartTiers: d.cartTiers || '', scarcityThreshold: parseInt(d.scarcityThreshold, 10) || 0,
      xsellHas: d.xsellHas || '', xsellMissing: d.xsellMissing || '', xsellAdd: d.xsellAdd || '',
      fontScale: parseInt(d.fontScale, 10) || 100
    };
  }
  var configs = bars.map(cfg);

  function isDismissed(h) { try { return sessionStorage.getItem('soolla_bar_dismissed_' + h) === '1'; } catch (e) { return false; } }
  function isUtmMatched(c) { return !!(c.utmSource || c.utmCampaign || c.utmMedium); }
  function isCountrySpecific(c) { return c.countries.length > 0 && c.countries.indexOf('*') === -1; }

  function utmFieldMatch(pattern, value) {
    if (!pattern) return null;
    value = (value || '').toLowerCase();
    var alts = pattern.split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    for (var i = 0; i < alts.length; i++) { if (alts[i] === '*' && value) return true; if (alts[i] === value) return true; }
    return false;
  }

  /* sticky A/B assignment */
  var abCache = {};
  function abChoice(testId) {
    if (abCache[testId]) return abCache[testId];
    var ck = 'soolla_ab_' + testId, v = cookieGet(ck);
    if (!v) {
      var variants = configs.filter(function (c) { return c.abTest === testId; });
      var total = variants.reduce(function (s, c) { return s + (c.abWeight || 1); }, 0) || 1;
      var r = Math.random() * total, acc = 0, pick = variants.length ? variants[0].variant : '';
      for (var i = 0; i < variants.length; i++) { acc += variants[i].abWeight || 1; if (r <= acc) { pick = variants[i].variant; break; } }
      v = pick; cookieSet(ck, v, 30);
    }
    abCache[testId] = v; return v;
  }

  /* daily-recurring window check in store tz */
  function laMinutesNow() {
    try {
      var p = new Intl.DateTimeFormat('en-US', { timeZone: 'America/Los_Angeles', hour12: false, hour: '2-digit', minute: '2-digit', second: '2-digit' }).formatToParts(new Date());
      var h = 0, m = 0, s = 0;
      p.forEach(function (x) { if (x.type === 'hour') h = +x.value; if (x.type === 'minute') m = +x.value; if (x.type === 'second') s = +x.value; });
      return (h * 60 + m) + s / 60;
    } catch (e) { var n = new Date(); return n.getHours() * 60 + n.getMinutes(); }
  }
  function parseWindow(win) {
    var m = (win || '').match(/^\s*(\d{1,2}):(\d{2})\s*-\s*(\d{1,2}):(\d{2})\s*$/);
    if (!m) return null;
    return { start: (+m[1]) * 60 + (+m[2]), end: (+m[3]) * 60 + (+m[4]) };
  }
  function inDailyWindow(c) {
    var w = parseWindow(c.cdWindow); if (!w) return true;
    var now = laMinutesNow();
    if (w.end >= w.start) return now >= w.start && now <= w.end;
    return now >= w.start || now <= w.end; // overnight
  }

  /* ---------- eligibility ---------- */
  function eligible(c) {
    if (isDismissed(c.handle)) return false;
    if (DESIGN) return true;
    if (isCountrySpecific(c) && c.countries.indexOf(geo.country) === -1) return false;
    if (c.regions.length) {
      var rm = c.regions.some(function (r) {
        return r === geo.region || r === (geo.country + '-' + geo.region) || (geo.city && r === geo.city.toUpperCase());
      });
      if (!rm) return false;
    }
    if (c.segment === 'new' && isReturning) return false;
    if (c.segment === 'returning' && !isReturning) return false;
    var checks = [utmFieldMatch(c.utmSource, utm.source), utmFieldMatch(c.utmCampaign, utm.campaign), utmFieldMatch(c.utmMedium, utm.medium)].filter(function (x) { return x !== null; });
    if (checks.length) {
      if (c.matchLogic === 'any') { if (!checks.some(Boolean)) return false; }
      else { if (!checks.every(Boolean)) return false; }
    }
    if (c.type === 'countdown' && c.cdMode === 'daily_recurring' && !inDailyWindow(c)) return false;
    if (c.abTest && abChoice(c.abTest) !== c.variant) return false;
    if ((c.type === 'cart_progress' || c.type === 'scarcity' || c.type === 'cross_sell') && !c._ready) return false;
    return true;
  }

  var slotRank = { primary: 0, secondary: 1, tertiary: 2 };
  function rankOfSlot(s) { return (s in slotRank) ? slotRank[s] : 50; }

  /* ---------- choose winners + reveal ---------- */
  function chooseAndRender() {
    var bySlot = {};
    configs.forEach(function (c) { if (eligible(c)) (bySlot[c.slot] = bySlot[c.slot] || []).push(c); });
    var shown = {};
    Object.keys(bySlot).forEach(function (slot) {
      var cands = bySlot[slot];
      cands.sort(function (a, b) {
        var au = isUtmMatched(a) ? 1 : 0, bu = isUtmMatched(b) ? 1 : 0; if (au !== bu) return bu - au;
        var ac = isCountrySpecific(a) ? 1 : 0, bc = isCountrySpecific(b) ? 1 : 0; if (ac !== bc) return bc - ac;
        return b.priority - a.priority;
      });
      var w = cands[0]; shown[w.handle] = true; w.el.style.order = rankOfSlot(slot);
    });
    configs.forEach(function (c) {
      var show = !!shown[c.handle];
      if (show) {
        c.el.removeAttribute('hidden');
        c.el.classList.add('is-shown');
        if (!c.el.__inited) { initBar(c); }
        logImpression(c);
      } else {
        c.el.classList.remove('is-shown');
        c.el.setAttribute('hidden', '');
      }
    });
  }

  /* ---------- analytics ---------- */
  function beacon(payload) {
    try {
      if (!logEndpoint) return;
      var body = JSON.stringify(payload);
      if (navigator.sendBeacon) navigator.sendBeacon(logEndpoint, body);
      else fetch(logEndpoint, { method: 'POST', body: body, keepalive: true, mode: 'no-cors' }).catch(function () {});
    } catch (e) {}
  }
  function logImpression(c) {
    if (loggedImpr[c.handle]) return; loggedImpr[c.handle] = true;
    beacon({ t: 'impression', bar: c.handle, variant: c.variant, test: c.abTest, country: geo.country, slot: c.slot });
  }
  function ga4(name, params) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: name }, params));
      if (typeof window.gtag === 'function') window.gtag('event', name, params);
    } catch (e) {}
  }

  /* ---------- CTA + UTM injection ---------- */
  function injectUtm(url, c) {
    try {
      var abs = new URL(url, location.origin);
      if (c.injectUtm) {
        if (!abs.searchParams.get('utm_source')) abs.searchParams.set('utm_source', 'announcement_bar');
        if (!abs.searchParams.get('utm_medium')) abs.searchParams.set('utm_medium', 'banner');
        if (c.ctaUtmCampaign && !abs.searchParams.get('utm_campaign')) abs.searchParams.set('utm_campaign', c.ctaUtmCampaign);
        abs.searchParams.set('utm_content', 'bar-' + c.handle.replace(/^bar-/, '') + (c.variant ? '-' + c.variant : ''));
      }
      return (abs.origin === location.origin) ? (abs.pathname + abs.search + abs.hash) : abs.toString();
    } catch (e) { return url; }
  }
  function finalHref(c) {
    var target = injectUtm(c.ctaUrl || '/', c);
    if (c.discount) {
      // UTMs ride INSIDE the redirect target (Shopify strips siblings across /discount/ bounce)
      return '/discount/' + encodeURIComponent(c.discount) + '?redirect=' + encodeURIComponent(target);
    }
    return target;
  }
  function onCtaActivate(c, extra) {
    ga4('select_promotion', Object.assign({ promotion_id: 'bar-' + c.handle, promotion_name: c.handle, creative_slot: c.slot, variant: c.variant || '' }, extra || {}));
    beacon(Object.assign({ t: 'click', bar: c.handle, variant: c.variant, test: c.abTest, country: geo.country }, extra ? { msg: extra.index } : {}));
    if (c.abTest || c.variant) {
      try {
        fetch('/cart/update.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' }, keepalive: true,
          body: JSON.stringify({ attributes: { _soolla_bar: c.handle, _soolla_variant: c.variant || '', _soolla_country: geo.country } })
        }).catch(function () {});
      } catch (e) {}
    }
  }
  function setupCta(c) {
    var link = c.el.querySelector('a[data-cta]');
    if (link) {
      if (c.ctaUrl || c.discount) link.setAttribute('href', finalHref(c));
      link.addEventListener('click', function () { onCtaActivate(c); });
    } else if (c.ctaUrl && c.type !== 'email_capture' && c.type !== 'sms_capture') {
      c.el.classList.add('soolla-bar--linkable');
      c.el.addEventListener('click', function (e) {
        if (e.target.closest('[data-close],[data-copy],a,button,input,form')) return;
        onCtaActivate(c);
        window.location.href = finalHref(c);
      });
    }
  }

  /* ---------- discount copy ---------- */
  function setupCopy(c) {
    var btn = c.el.querySelector('[data-copy]'); if (!btn) return;
    btn.addEventListener('click', function () {
      var code = btn.getAttribute('data-copy');
      var done = function () {
        btn.classList.add('is-copied');
        var lab = btn.querySelector('.soolla-bar__copy-label'); if (lab) lab.textContent = 'Copied ✓';
        beacon({ t: 'copy', bar: c.handle, code: code });
        setTimeout(function () { btn.classList.remove('is-copied'); if (lab) lab.textContent = 'Copy'; }, 2000);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(done).catch(function () { fallbackCopy(code, done); });
      else fallbackCopy(code, done);
    });
  }
  function fallbackCopy(text, cb) {
    try {
      var t = document.createElement('textarea'); t.value = text; t.style.position = 'fixed'; t.style.opacity = '0';
      document.body.appendChild(t); t.select(); document.execCommand('copy'); document.body.removeChild(t); cb();
    } catch (e) {}
  }

  /* ---------- dismiss ---------- */
  function setupClose(c) {
    var btn = c.el.querySelector('[data-close]'); if (!btn) return;
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      try { sessionStorage.setItem('soolla_bar_dismissed_' + c.handle, '1'); } catch (er) {}
      if (reduceMotion) { c.el.classList.remove('is-shown'); c.el.setAttribute('hidden', ''); }
      else {
        c.el.classList.add('is-collapsing');
        setTimeout(function () { c.el.classList.remove('is-shown', 'is-collapsing'); c.el.setAttribute('hidden', ''); chooseAndRender(); }, 300);
      }
    });
  }

  /* ---------- per-message links ---------- */
  // No UTMs here: UTM params on internal links start a new GA4 session and overwrite the real source.
  function msgHref(c, url) {
    return c.discount ? '/discount/' + encodeURIComponent(c.discount) + '?redirect=' + encodeURIComponent(url) : url;
  }
  function setupMessageLinks(c) {
    Array.prototype.forEach.call(c.el.querySelectorAll('[data-msg-link]'), function (a) {
      var m = c.messages[parseInt(a.getAttribute('data-msg-index'), 10) || 0];
      if (m && m.url) a.setAttribute('href', msgHref(c, m.url));
    });
    c.el.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('[data-msg-link]');
      if (!a) return;
      var n = parseInt(a.getAttribute('data-msg-index'), 10) || 0, m = c.messages[n];
      onCtaActivate(c, { creative_name: m ? pickCopy(m.copy) : '', index: n });
    });
  }

  /* ---------- rotating announcement: 2+ messages, "Lift" hand-off ---------- */
  function initRotator(c) {
    var stage = c.el.querySelector('.soolla-bar__rot-stack');
    if (!stage || c.messages.length < 2) return;
    var HOLD = Math.min(30, Math.max(2, c.hold)) * 1000;
    var items = [], idx = 0, busy = false, queued = 0, running = [], timer = null, dueAt = 0, left = 0, token = 0, holds = {};
    function held() { for (var k in holds) return true; return false; }
    function build() {
      stage.textContent = '';
      items = c.messages.map(function (m, n) {
        var it = document.createElement(m.url ? 'a' : 'span');
        it.className = 'soolla-bar__msg soolla-bar__rot-item' + (n === idx ? ' is-on' : '');
        if (m.url) { it.setAttribute('href', msgHref(c, m.url)); it.setAttribute('data-msg-link', ''); it.setAttribute('data-msg-index', String(n)); }
        if (n !== idx) it.setAttribute('aria-hidden', 'true');
        var t = document.createElement('span'); t.className = 'soolla-bar__rot-txt'; t.textContent = pickCopy(m.copy);
        it.appendChild(t); stage.appendChild(it);
        return it;
      });
    }
    function schedule(ms) {
      clearTimeout(timer); timer = null; left = ms;
      if (held() || busy) return;
      dueAt = Date.now() + ms;
      timer = setTimeout(function () { timer = null; go(1); }, ms);
    }
    function lift(o, i, d) {
      if (typeof i.animate !== 'function') return [];
      if (reduceMotion) return [
        o.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 200, easing: 'ease-in', fill: 'both' }),
        i.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 280, delay: 140, easing: 'ease-out', fill: 'both' })
      ];
      return [
        o.animate([{ opacity: 1, transform: 'translateY(0px)' }, { opacity: 0, transform: 'translateY(' + (-7 * d) + 'px)' }], { duration: 280, easing: 'cubic-bezier(.4,0,1,1)', fill: 'both' }),
        i.animate([{ opacity: 0, transform: 'translateY(' + (9 * d) + 'px)' }, { opacity: 1, transform: 'translateY(0px)' }], { duration: 600, delay: 200, easing: 'cubic-bezier(.16,1,.3,1)', fill: 'both' })
      ];
    }
    function go(d) {
      if (items.length < 2) return;
      if (busy) { queued = d; return; }
      busy = true; clearTimeout(timer); timer = null;
      var my = token, o = items[idx], n = (idx + d + items.length) % items.length, i = items[n];
      i.classList.add('is-on'); i.removeAttribute('aria-hidden');
      running = lift(o, i, d);
      // done() runs exactly once: when the animations finish, if one is cancelled from outside, or
      // after a safety timeout — so the bar can never stall with two messages overlapping.
      var settled = false, safety;
      var done = function () {
        if (settled || my !== token) return;
        settled = true; clearTimeout(safety);
        o.classList.remove('is-on'); o.setAttribute('aria-hidden', 'true');
        running.forEach(function (a) { try { a.cancel(); } catch (e) {} }); running = [];
        idx = n; busy = false;
        if (queued) { var q = queued; queued = 0; go(q); } else schedule(HOLD);
      };
      safety = setTimeout(done, 1200);
      var fin = running.map(function (a) { return a.finished; }).filter(Boolean);
      if (!fin.length || fin.length < running.length) done();
      else Promise.all(fin).then(done, done);
    }
    // Pause while a shopper is reading or interacting; resume with the time that was left.
    function hold(r) { holds[r] = 1; if (timer) { clearTimeout(timer); timer = null; left = Math.max(0, dueAt - Date.now()); } }
    function release(r) { delete holds[r]; if (!held() && !busy && !timer) schedule(Math.max(800, left || HOLD)); }
    if (window.PointerEvent) {
      c.el.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') hold('hover'); });
      c.el.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') release('hover'); });
    }
    c.el.addEventListener('touchstart', function () { hold('touch'); }, { passive: true });
    c.el.addEventListener('touchend', function () { release('touch'); }, { passive: true });
    c.el.addEventListener('touchcancel', function () { release('touch'); }, { passive: true });
    c.el.addEventListener('focusin', function (e) { var fv = true; try { fv = e.target.matches(':focus-visible'); } catch (x) {} if (fv) hold('focus'); });
    c.el.addEventListener('focusout', function () { release('focus'); });
    document.addEventListener('visibilitychange', function () { if (document.hidden) hold('hidden'); else release('hidden'); });
    if (document.hidden) hold('hidden'); // opened in a background tab: don't rotate until it's seen
    c._rot = {
      rebuild: function () {
        token++;
        running.forEach(function (a) { try { a.cancel(); } catch (e) {} });
        running = []; busy = false; queued = 0;
        build(); schedule(HOLD);
      }
    };
    build();
    schedule(HOLD);
  }

  /* ---------- marquee ---------- */
  function initMarquee(c) {
    var marquee = c.el.querySelector('.soolla-bar__marquee');
    var track = c.el.querySelector('.soolla-bar__track');
    var msg = track && track.querySelector('.soolla-bar__msg');
    if (!marquee || !track || !msg) return;
    if (hasSplitCopy(c)) msg.textContent = c.template;
    c._marqueeMsg = msg;
    // static: render one centred copy, never clone or animate
    if (c.motion === 'static') {
      var placeStatic = function () {
        track.classList.remove('is-animating');
        track.style.removeProperty('--marquee-dur');
        track.innerHTML = '';
        track.appendChild(msg.cloneNode(true));
      };
      c._rebuildMarquee = placeStatic;
      placeStatic();
      return;
    }
    var build = function () {
      // reset to one msg
      track.innerHTML = '';
      track.appendChild(msg.cloneNode(true));
      var containerW = marquee.clientWidth || 1;
      // fill one group to at least container width
      var guard = 0;
      while (track.scrollWidth < containerW && guard < 40) { track.appendChild(msg.cloneNode(true)); guard++; }
      var groupWidth = track.scrollWidth;
      var groupCount = track.children.length;
      // duplicate the group once for seamless -50% loop
      for (var i = 0; i < groupCount; i++) track.appendChild(track.children[i].cloneNode(true));
      if (!reduceMotion) {
        var dur = Math.max(8, groupWidth / 70); // ~70px/sec, constant speed
        track.style.setProperty('--marquee-dur', dur + 's');
        track.classList.add('is-animating');
      }
    };
    c._rebuildMarquee = build;
    build();
    var ro; try { ro = new ResizeObserver(function () { track.classList.remove('is-animating'); build(); }); ro.observe(marquee); } catch (e) {}
  }

  /* ---------- countdown ---------- */
  function targetFor(c) {
    if (c.cdMode === 'evergreen') {
      var key = 'soolla_evg_' + c.handle, start;
      try { start = parseInt(localStorage.getItem(key), 10); } catch (e) {}
      if (!start) { start = Date.now(); try { localStorage.setItem(key, String(start)); } catch (e) {} }
      return start + (c.cdDuration || 0) * 60000;
    }
    if (c.cdMode === 'daily_recurring') {
      var w = parseWindow(c.cdWindow); if (!w) return 0;
      var rem = (w.end - laMinutesNow()) * 60; if (rem < 0) rem += 24 * 3600;
      return Date.now() + rem * 1000;
    }
    return c.cdDeadline ? Date.parse(c.cdDeadline) : 0;
  }
  function fmt(ms) {
    if (ms < 0) ms = 0;
    var s = Math.floor(ms / 1000), d = Math.floor(s / 86400); s -= d * 86400;
    var h = Math.floor(s / 3600); s -= h * 3600;
    var m = Math.floor(s / 60); s -= m * 60;
    var p = function (n) { return (n < 10 ? '0' : '') + n; };
    return (d > 0 ? d + 'd ' : '') + p(h) + ':' + p(m) + ':' + p(s);
  }
  function initCountdown(c) {
    var out = c.el.querySelector('[data-timer]'); if (!out) return;
    var target = targetFor(c);
    if (!target) { out.textContent = ''; return; }
    var tick = function () {
      var rem = target - Date.now();
      if (rem <= 0) {
        clearInterval(c._iv);
        if (c.success) { var msg = c.el.querySelector('.soolla-bar__msg'); if (msg) msg.textContent = c.success; out.textContent = ''; }
        else { c.el.classList.remove('is-shown'); c.el.setAttribute('hidden', ''); chooseAndRender(); }
        return;
      }
      out.textContent = fmt(rem);
    };
    tick(); c._iv = setInterval(tick, 1000);
  }

  /* ---------- free shipping (cart-aware) ---------- */
  function renderFreeShip(c, totalCents) {
    var msg = c.el.querySelector('.soolla-bar__msg'); if (!msg) return;
    var remaining = c.threshold - totalCents;
    if (remaining <= 0) { msg.textContent = c.success || 'You unlocked free shipping!'; }
    else { msg.textContent = fillTokens(c.template, { remaining: money(remaining), threshold: money(c.threshold) }); }
  }
  function initFreeShipping(c) {
    var fetchCart = function () {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { renderFreeShip(c, cart.total_price || 0); })
        .catch(function () { renderFreeShip(c, 0); });
    };
    fetchCart();
    ['cart:updated', 'cart:refresh', 'ajaxCart.afterCartLoad', 'cart:change'].forEach(function (ev) { document.addEventListener(ev, fetchCart); });
    window.addEventListener('focus', fetchCart);
    // UpCart drawer: re-check when it mutates
    var up = document.getElementById('upCart');
    if (up) { try { new MutationObserver(function () { fetchCart(); }).observe(up, { childList: true, subtree: true }); } catch (e) {} }
  }

  /* ---------- capture (Klaviyo dormant) ---------- */
  function initCapture(c) {
    var form = c.el.querySelector('[data-capture-form]'); if (!form) return;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (form.querySelector('.soolla-bar__hp') && form.querySelector('.soolla-bar__hp').value) return; // bot
      var input = form.querySelector('.soolla-bar__input'); var val = input ? input.value.trim() : '';
      if (!val) { input && input.focus(); return; }
      var succeed = function () {
        var inner = c.el.querySelector('.soolla-bar__inner');
        if (inner) inner.innerHTML = '<span class="soolla-bar__msg">' + (c.success || 'Thanks — you’re in!') + '</span>';
        beacon({ t: 'capture', bar: c.handle, type: c.captureType });
        ga4('generate_lead', { method: 'announcement_bar', bar: c.handle });
      };
      if (!KLAVIYO_ENABLED || !c.klaviyoList) { succeed(); return; } // dormant: optimistic success
      // (live Klaviyo client subscribe would go here)
      succeed();
    });
  }

  /* ---------- social proof (fictitious feed) ---------- */
  var SP_SAMPLE = [
    { city: 'Toronto', product: 'Studio Bag', mins: 3 }, { city: 'Austin', product: 'Studio Pouch', mins: 8 },
    { city: 'Brooklyn', product: 'Studio Bundle', mins: 12 }, { city: 'Portland', product: 'Studio Bag', mins: 17 },
    { city: 'Vancouver', product: 'Studio Pouch', mins: 24 }, { city: 'Chicago', product: 'Studio Bundle', mins: 31 }
  ];
  function initSocialProof(c) {
    var msg = c.el.querySelector('.soolla-bar__msg'); if (!msg) return;
    var items = SP_SAMPLE.slice();
    var i = 0;
    var show = function () {
      var s = items[i % items.length]; i++;
      msg.textContent = fillTokens(c.template, { city: s.city, product: s.product, mins: String(s.mins) });
    };
    show(); c._sp = setInterval(show, 6000);
    try { var base = (geoEndpoint || '').split('/geo')[0]; if (base && base !== geoEndpoint) { fetch(base + '/social?window=' + (c.spWindow || 24), { mode: 'cors' }).then(function (r) { return r.json(); }).then(function (d) { if (d && d.items && d.items.length) { items = d.items.map(function (x) { return { city: x.city || x.region || x.country || 'Someone', product: x.product || 'an order', mins: Math.max(1, Math.round((Date.now() - (x.ts || Date.now())) / 60000)) }; }); } }).catch(function () {}); } } catch (e) {}
  }

  /* ---------- init one bar ---------- */
  function initBar(c) {
    if (c.el.__inited) return; c.el.__inited = true;
    c.el.style.setProperty('--font-scale', (c.fontScale || 100) / 100);
    setupCta(c); setupCopy(c); setupClose(c);
    if (hasSplitCopy(c) && c.type !== 'announcement') syncCopy(c);
    if (c.type === 'announcement') { setupMessageLinks(c); if (c.messages.length > 1) initRotator(c); else initMarquee(c); }
    else if (c.type === 'countdown') initCountdown(c);
    else if (c.type === 'free_shipping') initFreeShipping(c);
    else if (c.type === 'email_capture' || c.type === 'sms_capture') initCapture(c);
    else if (c.type === 'social_proof') initSocialProof(c);
  }

  /* ---------- geo upgrade ---------- */
  function upgradeGeo() {
    if (!geoUpgrade || DESIGN) return;
    var done = false;
    var apply = function (country, region, city) {
      if (done) return; done = true;
      if (country) geo.country = String(country).toUpperCase();
      if (region) geo.region = String(region).toUpperCase();
      if (city) geo.city = city;
      chooseAndRender();
    };
    var fallback = function () {
      fetch('https://api.country.is/', { mode: 'cors' }).then(function (r) { return r.json(); })
        .then(function (d) { apply(d.country); }).catch(function () {});
    };
    if (geoEndpoint) {
      fetch(geoEndpoint, { mode: 'cors' }).then(function (r) { if (!r.ok) throw 0; return r.json(); })
        .then(function (d) { apply(d.country, d.region, d.city); }).catch(fallback);
    } else { fallback(); }
  }

  /* ---------- AOV: cart progress / cross-sell / scarcity ---------- */
  var cartListenersAttached = false;
  function parseTiers(s) {
    return (s || '').split('\n').map(function (l) { var p = l.split('|'); return { amt: parseInt(p[0], 10) || 0, reward: (p[1] || '').trim() }; })
      .filter(function (t) { return t.amt > 0; }).sort(function (a, b) { return a.amt - b.amt; });
  }
  function renderCartProgress(c, total) {
    var tiers = parseTiers(c.cartTiers);
    if (!tiers.length && c.threshold) tiers = [{ amt: c.threshold, reward: 'free shipping' }];
    var msg = c.el.querySelector('.soolla-bar__msg'), fill = c.el.querySelector('[data-progress]');
    var next = null; for (var i = 0; i < tiers.length; i++) { if (total < tiers[i].amt) { next = tiers[i]; break; } }
    if (next) {
      if (msg) msg.textContent = fillTokens(c.template, { remaining: money(next.amt - total), threshold: money(next.amt), reward: next.reward });
      if (fill) { var prev = 0; for (var j = 0; j < tiers.length; j++) { if (tiers[j].amt <= total) prev = tiers[j].amt; } var span = next.amt - prev; fill.style.width = Math.max(3, Math.min(100, span > 0 ? ((total - prev) / span) * 100 : 0)) + '%'; }
    } else {
      if (msg) msg.textContent = c.success || 'All rewards unlocked!';
      if (fill) fill.style.width = '100%';
    }
    c._ready = true;
  }
  function cartHasKey(cart, key) {
    if (!key) return false; key = key.toLowerCase();
    return (cart.items || []).some(function (it) {
      return (it.handle || '').toLowerCase() === key || (it.product_id + '') === key ||
        ((it.product_type || '').toLowerCase() === key) || (it.product_title || '').toLowerCase().indexOf(key) > -1 ||
        ((it.product_tags || []).map(String).join(',').toLowerCase().indexOf(key) > -1);
    });
  }
  function renderCrossSell(c, cart) {
    var items = cart.items || [];
    var has = c.xsellHas ? cartHasKey(cart, c.xsellHas) : items.length > 0;
    var missing = c.xsellMissing ? !cartHasKey(cart, c.xsellMissing) : true;
    c._ready = items.length > 0 && has && missing;
    if (c._ready) { var msg = c.el.querySelector('.soolla-bar__msg'); if (msg) msg.textContent = fillTokens(c.template, { product: '' }); }
  }
  function refreshCartBars() {
    var cbars = configs.filter(function (c) { return c.type === 'cart_progress' || c.type === 'cross_sell'; });
    if (!cbars.length) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      cbars.forEach(function (c) { if (c.type === 'cart_progress') renderCartProgress(c, cart.total_price || 0); else renderCrossSell(c, cart); });
      chooseAndRender();
    }).catch(function () { cbars.forEach(function (c) { if (c.type === 'cart_progress') renderCartProgress(c, 0); }); chooseAndRender(); });
  }
  function prepareCartBars() {
    if (!configs.some(function (c) { return c.type === 'cart_progress' || c.type === 'cross_sell'; })) return;
    refreshCartBars();
    if (!cartListenersAttached) {
      cartListenersAttached = true;
      ['cart:updated', 'cart:refresh', 'cart:change', 'ajaxCart.afterCartLoad'].forEach(function (ev) { document.addEventListener(ev, refreshCartBars); });
      window.addEventListener('focus', refreshCartBars);
      var up = document.getElementById('upCart');
      if (up) { try { new MutationObserver(function () { refreshCartBars(); }).observe(up, { childList: true, subtree: true }); } catch (e) {} }
    }
  }
  function prepareScarcity() {
    var sbars = configs.filter(function (c) { return c.type === 'scarcity'; });
    if (!sbars.length || pageType !== 'product') return;
    var m = location.pathname.match(/\/products\/([^/?#]+)/); var handle = m ? m[1] : '';
    var base = (geoEndpoint || '').split('/geo')[0];
    if (!handle || !base) return;
    fetch(base + '/inventory?handle=' + encodeURIComponent(handle), { mode: 'cors' }).then(function (r) { return r.json(); }).then(function (d) {
      var stock = d && typeof d.available === 'number' ? d.available : null;
      sbars.forEach(function (c) {
        var th = c.scarcityThreshold || 5;
        if (stock !== null && stock > 0 && stock <= th) {
          var msg = c.el.querySelector('.soolla-bar__msg'); if (msg) msg.textContent = fillTokens(c.template, { stock: String(stock) });
          c._ready = true;
        }
      });
      chooseAndRender();
    }).catch(function () {});
  }


  /* ---------- responsive copy: apply + re-apply on breakpoint change ---------- */
  function syncCopy(c) {
    if (c.type === 'announcement') {
      if (c._rot) { c._rot.rebuild(); return; }
      if (!c._marqueeMsg) return;
      c._marqueeMsg.textContent = c.template;
      var tr = c.el.querySelector('.soolla-bar__track');
      if (tr) tr.classList.remove('is-animating');
      if (c._rebuildMarquee) c._rebuildMarquee();
      return;
    }
    var m = c.el.querySelector('.soolla-bar__msg');
    if (m) m.textContent = fillTokens(c.template, { remaining: '', threshold: '', city: '', product: '', stock: '', reward: '', mins: '' }).trim();
  }
  function onBreakpointChange() {
    var touched = false;
    configs.forEach(function (c) {
      if (!hasSplitCopy(c)) return;
      c.template = pickCopy(c.templateRaw);
      c.success = pickCopy(c.successRaw);
      if (c.el.classList.contains('is-shown')) { syncCopy(c); touched = true; }
    });
    if (touched) { refreshCartBars(); prepareScarcity(); }
  }
  if (MOBILE_MQ) {
    if (MOBILE_MQ.addEventListener) MOBILE_MQ.addEventListener('change', onBreakpointChange);
    else if (MOBILE_MQ.addListener) MOBILE_MQ.addListener(onBreakpointChange);
  }

  /* ---------- go ---------- */
  chooseAndRender();
  upgradeGeo();
  prepareCartBars();
  prepareScarcity();
})();
